<template>
  <aside class="mobile-note" aria-label="About this score">
    <span class="mobile-note-icon" aria-hidden="true"><ph-icon name="device-mobile" :size="20" /></span>
    <p>
      <strong>Your visitors are on their phone, so is this score.</strong>
      More than half of all web traffic is mobile, so we test your form on a mobile screen, not a desktop.
      What you see here is what most of your visitors get.
    </p>
  </aside>
</template>

<script>
import PhIcon from './PhIcon.vue'

export default {
  name: 'MobileNote',
  components: { PhIcon }
}
</script>

<style scoped>
.mobile-note {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 16px 20px;
  border-radius: var(--ex-radius-tile);
  background: var(--ex-color-surface-blue);
  font-size: 14px;
  line-height: 1.55;
  color: var(--ex-color-neutral-700);
}

.mobile-note-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex: none;
  border-radius: var(--ex-radius-pill);
  background: var(--ex-color-white);
  color: var(--ex-color-blue);
}

.mobile-note p {
  align-self: center;
}

.mobile-note strong {
  font-weight: 600;
  color: var(--ex-color-dark);
}
</style>
